export const BENTO_ANALYTICS_DATA_PROPERTY = 'data-bentoanalytics';
export const BENTO_ANALYTICS_SNOWPLOW_APP_ID = 'customer-websites';

export const RESERVATIONS = 'Reservations';
export const THEME_AGNOSTIC = 'theme_agnostic';

export const eventActions = {
  CHANGE: 'Change',
  CLICK: 'Click',
  SHOW: 'Show',
  SUBMIT: 'Submit'
};

export const eventLabels = {
  BOOK_NEW_RESERVATION_AFTER_CANCELLATION:
    'Book New Reservation After Cancellation',
  CANCEL_BOOKING: 'Cancel Booking',
  CREATE_BOOKING: 'Create Booking',
  DATE_SELECTION: 'Date Selection',
  NEVERMIND_CLICK: 'Nevermind Click',
  PARTY_SIZE_SELECTION: 'Party Size Selection',
  TIME_SLOT_SELECTION: 'Time Slot Selection',
  UPDATE_BOOKING: 'Update Booking'
};
